import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHeadingSwapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={27} fill="none" {...props}>
    <path fill="#B2B2B2" d="M8.125 26.5v-4.875H26v-3.25H8.125V13.5H6.5L0 20l6.5 6.5zM17.875 13.5V8.625H0v-3.25h17.875V.5H19.5L26 7l-6.5 6.5z" />
  </svg>
);
export default SvgHeadingSwapIcon;
